package com.kitco.metalynxscrapit.shared.presentation.more

import com.kitco.metalynxscrapit.shared.domain.model.AppTimeZone
import com.kitco.metalynxscrapit.shared.domain.model.Language

data class MoreUiState(
    val language: Language,
    val timeZone: AppTimeZone
)
